// src/hooks/useSafeTimeout.js
import { useRef, useEffect, useCallback } from 'react';

export const useSafeTimeout = () => {
  const mountedRef = useRef(true);
  const timersRef = useRef([]);

  useEffect(() => {
    mountedRef.current = true;
    
    return () => {
      mountedRef.current = false;
      timersRef.current.forEach(timer => clearTimeout(timer));
      timersRef.current = [];
    };
  }, []);

  const setSafeTimeout = useCallback((callback, delay) => {
    const timer = setTimeout(() => {
      if (mountedRef.current) {
        callback();
      }
    }, delay);
    
    timersRef.current.push(timer);
    return timer;
  }, []);

  const clearSafeTimeout = useCallback((timer) => {
    clearTimeout(timer);
    timersRef.current = timersRef.current.filter(t => t !== timer);
  }, []);

  return { 
    setSafeTimeout, 
    clearSafeTimeout, 
    isMounted: mountedRef 
  };
};